"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlag = getFlag;
var _flags = require("./flags");
function getFlag(code) {
  try {
    var shortCode = code.slice(0, 2).toLowerCase();
    return shortCode in _flags.FLAGS ? _flags.FLAGS[shortCode] : '';
  } catch (e) {
    return '';
  }
}